import { useSelector } from "react-redux";
import { intersection } from "lodash-es";

const ELECTIONS_BAR_FEATURE_FLAG_KEY = "election.electionsBar";

export const useElectionsBarData = () => {
    const storyTags =
        useSelector((state) => state?.detail?.content?.tags) || [];
    const isInNewsSection = useSelector(
        (state) => state?.app?.baseSection === "news"
    );
    const isLiveStoryPage = useSelector(
        (state) => !!state?.liveStory?.content?.id
    );
    const electionsBar = useSelector(
        (state) => state?.featureflags?.[ELECTIONS_BAR_FEATURE_FLAG_KEY]
    );

    if (!isInNewsSection) {
        return null;
    }

    if (isLiveStoryPage) {
        return null;
    }

    if (!electionsBar || !electionsBar.displayElectionsBar) {
        return null;
    }

    const storyTagNames = storyTags.map(({ name }) => name.toLowerCase());
    const electionsBarTagNames = electionsBar.tags.map((tag) =>
        tag.toLowerCase()
    );
    const storyTagsIncludeElectionsBarTags =
        intersection(storyTagNames, electionsBarTagNames).length > 0;

    return storyTagsIncludeElectionsBarTags ? electionsBar.links : null;
};
